import React, { useContext } from "react";
import { Grid, Stack, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
// icon
//Srcs
import "./setting.scss";
import { AuthContext } from "../Context/AuthContext";

import users from "../Assets/SettingIcons/login.png";
import Category from "../Assets/SettingIcons/folder-management.png";
import unit from "../Assets/SettingIcons/unit.png";
import size from "../Assets/SettingIcons/parcel.png";
import supplier from "../Assets/SettingIcons/vendor-spp.png";
import group from "../Assets/SettingIcons/aggregate.png";
import material from "../Assets/SettingIcons/in-store-display.png";
import warehouse from "../Assets/SettingIcons/storage-stacks.png";
import office from "../Assets/SettingIcons/office-building.png";
import classroom from "../Assets/SettingIcons/classroom.png";
import book from "../Assets/SettingIcons/stack-of-books.png";
import item from "../Assets/SettingIcons/child-care.png";

const SettingPlace = [
  {
    RouteTo: "/setting/warehouse",
    Title: "ឃ្លាំងទំនិញ",
    Description: "សម្រាប់បង្កើតឃ្លាំងទំនិញ",
    Icon: <img alt="warehouse" className="image" src={warehouse} />,
  },
  {
    RouteTo: "/setting/user",
    Title: "អ្នកប្រើប្រាស់",
    Description: "សម្រាប់បង្កើតអ្នកប្រើប្រាស់",
    Icon: <img alt="user" className="image" src={users} />,
  },
  {
    RouteTo: "/setting/office",
    Title: "ការិយាល័យ",
    Description: "សម្រាប់បង្កើតការិយាល័យ",
    Icon: <img alt="office" className="image" src={office} />,
  },
];


const SettingMaterial = [
  {
    RouteTo: "/setting/section",
    Title: "ផ្នែក",
    Description: "សម្រាប់បង្កើតផ្នែក",
    Icon: <img alt="group" className="image" src={group} />,
  },
  {
    RouteTo: "/setting/levelsection",
    Title: "កម្រិតនៃផ្នែក",
    Description: "សម្រាប់បង្កើតនៃផ្នែក",
    Icon: <img alt="group" className="image" src={group} />,
  },
  {
    RouteTo: "/setting/group",
    Title: "ក្រុម",
    Description: "សម្រាប់បង្កើតក្រុម",
    Icon: <img alt="group" className="image" src={group} />,
  },
  {
    RouteTo: "/setting/category",
    Title: "ប្រភេទ",
    Description: "សម្រាប់បង្កើតប្រភេទ",
    Icon: <img alt="category" className="image" src={Category} />,
  },
  {
    RouteTo: "/setting/unit",
    Title: "ខ្នាត",
    Description: "សម្រាប់បង្កើតខ្នាត",
    Icon: <img alt="unit" className="image" src={unit} />,
  },
  {
    RouteTo: "/setting/size",
    Title: "ទំហំ",
    Description: "សម្រាប់បង្កើតទំហំ",
    Icon: <img alt="size" className="image" src={size} />,
  },
  {
    RouteTo: "/setting/material",
    Title: "សម្ភារៈ",
    Description: "សម្រាប់បង្កើតសម្ភារៈ",
    Icon: <img alt="material" className="image" src={material} />,
  },
  {
    RouteTo: "/setting/class-needed-items",
    Title: "សម្ភារៈដែលថ្នាក់ត្រូវមាន",
    Description: "សម្រាប់បង្កើតសម្ភារៈដែលថ្នាក់ត្រូវមាន",
    Icon: <img alt="item" className="image" src={item} />,
  },
];

const SettingMaterialRole = [
  {
    RouteTo: "/setting/material",
    Title: "សម្ភារៈ",
    Description: "សម្រាប់បង្កើតសម្ភារៈ",
    Icon: <img alt="material" className="image" src={material} />,
  },
  {
    RouteTo: "/setting/category",
    Title: "ប្រភេទ",
    Description: "សម្រាប់បង្កើតប្រភេទ",
    Icon: <img alt="category" className="image" src={Category} />,
  },
  {
    RouteTo: "/setting/unit",
    Title: "ខ្នាត",
    Description: "សម្រាប់បង្កើតខ្នាត",
    Icon: <img alt="unit" className="image" src={unit} />,
  },
  {
    RouteTo: "/setting/size",
    Title: "ទំហំ",
    Description: "សម្រាប់បង្កើតទំហំ",
    Icon: <img alt="size" className="image" src={size} />,
  },
  {
    RouteTo: "/setting/class-needed-items",
    Title: "សម្ភារៈដែលថ្នាក់ត្រូវមាន",
    Description: "សម្រាប់បង្កើតសម្ភារៈដែលថ្នាក់ត្រូវមាន",
    Icon: <img alt="item" className="image" src={item} />,
  },
];

export default function Setting() {

  const { noneUserAccesse } = useContext(AuthContext);


  // {
  //     RouteTo: "/setting/materialname",
  //     Title: "ឈ្មោះសម្ភារៈ",
  //     Description: "សម្រាប់បង្កើតឈ្មោះសម្ភារៈ",
  //     Icon: <img alt="supplier" className="image" src={supplier} />,
  //   },
  // {
  //     RouteTo: "",
  //     Title: "ថ្នាក់រៀន",
  //     Description: "សម្រាប់បង្កើតថ្នាក់រៀន",
  //     Icon: <img alt="classroom" className="image" src={classroom} />,
  //   },
  //   {
  //     RouteTo: "",
  //     Title: "សៀវភៅ",
  //     Description: "សម្រាប់បង្កើតសៀវភៅ",
  //     Icon: <img alt="book" className="image" src={book} />,
  //   }, 


  return (
    <div className="setting-page">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className="page-title">ការកំណត់</Typography>
        </Stack>
      </Stack>
      <Box sx={{ mt: "30px" }}>

        <Grid container spacing={4}>
          {SettingPlace?.map((e, key) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
              <Link to={e?.RouteTo} style={{ textDecoration: "none" }}>
                <Stack
                  direction="row"
                  spacing={1.8}
                  className="setting-page-container"
                >
                  <Stack
                    direction="column"
                    justifyContent="center"
                    className="page-image"
                  >
                    {e.Icon}
                    {/* <img alt="Exam icon" className="image" src={user} /> */}
                  </Stack>
                  <Stack direction="column" justifyContent="center">
                    <Stack direction="column">
                      <Typography className="page-title">{e?.Title}</Typography>
                      <Typography className="page-description">
                        {e?.Description}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Link>
            </Grid>
          ))}
        </Grid>


        <Grid container spacing={4} sx={{ mt: "10px" }}>
          {noneUserAccesse(['StockController', 'Proposer']) ?
            SettingMaterialRole?.map((e, key) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                <Link to={e?.RouteTo} style={{ textDecoration: "none" }}>
                  <Stack
                    direction="row"
                    spacing={1.8}
                    className="setting-page-container"
                  >
                    <Stack
                      direction="column"
                      justifyContent="center"
                      className="page-image"
                    >
                      {e.Icon}
                      {/* <img alt="Exam icon" className="image" src={user} /> */}
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                      <Stack direction="column">
                        <Typography className="page-title">{e?.Title}</Typography>
                        <Typography className="page-description">
                          {e?.Description}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Link>
              </Grid>
            ))
            :
            SettingMaterial?.map((e, key) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                <Link to={e?.RouteTo} style={{ textDecoration: "none" }}>
                  <Stack
                    direction="row"
                    spacing={1.8}
                    className="setting-page-container"
                  >
                    <Stack
                      direction="column"
                      justifyContent="center"
                      className="page-image"
                    >
                      {e.Icon}
                      {/* <img alt="Exam icon" className="image" src={user} /> */}
                    </Stack>
                    <Stack direction="column" justifyContent="center">
                      <Stack direction="column">
                        <Typography className="page-title">{e?.Title}</Typography>
                        <Typography className="page-description">
                          {e?.Description}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Link>
              </Grid>
            ))
          }
        </Grid>

      </Box>
    </div>
  );
}
